import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { DollarSign, BadgePercent, Mailbox, Hourglass, Printer } from "lucide-react";

const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function Tile({ testid, icon: Icon, label, value, sub, accent }) {
  return (
    <div className="p-4 rounded-xl border border-border bg-background/40 hover:-translate-y-0.5 transition-transform duration-200" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-widest uppercase text-muted-foreground font-semibold">{label}</span>
        <Icon className={`h-4 w-4 ${accent}`} />
      </div>
      <div className="font-display text-2xl sm:text-3xl font-bold mt-2" data-testid={`${testid}-value`}>{value}</div>
      <div className="text-xs text-muted-foreground mt-1">{sub}</div>
    </div>
  );
}

export const PaymentsSummary = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/dashboard/payments").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <Card className="p-6 bg-card/60 border-border mt-4" data-testid="payments-dashboard">
      <div className="flex items-baseline justify-between mb-4 flex-wrap gap-2">
        <h3 className="font-display text-xl font-semibold">Payments & Mailing</h3>
        <span className="text-xs tracking-widest uppercase text-primary font-bold" data-testid="payments-month">{d.month}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Tile testid="pay-collected" icon={DollarSign} accent="text-emerald-400" label="Collected" value={money(d.collected)}
          sub={`${d.payments} payment${d.payments === 1 ? "" : "s"} · fees ${money(d.service_fees)} · postage ${money(d.postage)}`} />
        <Tile testid="pay-waived" icon={BadgePercent} accent="text-fuchsia-400" label="Waived Fees" value={d.waived_count}
          sub={`${money(d.discount_value)} in fees waived or discounted`} />
        <Tile testid="pay-mailed" icon={Mailbox} accent="text-sky-400" label="Letters Mailed" value={d.letters_mailed}
          sub={`${d.rounds_mailed} round${d.rounds_mailed === 1 ? "" : "s"} sent certified`} />
        <Tile testid="pay-queue" icon={Hourglass} accent="text-amber-400" label="In Progress" value={d.awaiting_payment + d.ready_to_print}
          sub={<span className="flex items-center gap-1">{d.awaiting_payment} awaiting payment · <Printer className="h-3 w-3" /> {d.ready_to_print} ready to print</span>} />
      </div>
    </Card>
  );
};
